import contract from '@mailobj-browser/front/js/contracts/contract.js'
import loader from './loader.js'

export default contract({
  loader
})
